import { getURLSearchParams } from '../../utils/searchParamUtils';

const useForcedExperiment = (flagKey) => {
  const searchParams = getURLSearchParams();
  const flagKeyParam = searchParams.get('flag-key');
  const variationKeyParam = searchParams.get('variation-key') || undefined;
  const isForcedEnabled = !!flagKeyParam && flagKeyParam === flagKey;
  return [isForcedEnabled, variationKeyParam];
};

export default useForcedExperiment;
